import React, { useEffect } from "react";
import { useAppState } from "src/app/state/StateProvider";
import AppFooter from "src/commun/composants/footer/AppFooter";
import AppRouteComposants from "src/routes/AppRouteComposants";
import { useAppText } from "src/commun/composants/AppText";
import MenuMonEspacePrive from "src/app/menu/MenuMonEspacePrive";
import styles from "./AppMonEspacePrive.scss";


/**
 * MonEspacePrive app content
 */
export default function AppMonEspacePriveContent() {
  const [state] = useAppState();
  const { tString } = useAppText();

  useEffect(() => {
    document.title = tString("global.titre");
  }, [state.traductions]);

  return (
    <div className={styles.appContainer}>
      <div className={`${styles.appContentContainer} container`}>
        <MenuMonEspacePrive/>
        <div className={styles.rowContent}>
          <AppRouteComposants/>
        </div>
        <AppFooter/>
      </div>
    </div>
  );
}
